import type { FormlyFieldConfig } from '@ngx-formly/core';

/** Built-in Material types whose default form-field wrapper must survive custom wrappers. */
const MATERIAL_FORM_FIELD_TYPES = new Set([
  'boolean',
  'checkbox',
  'datepicker',
  'enum',
  'input',
  'integer',
  'multicheckbox',
  'native-select',
  'number',
  'radio',
  'select',
  // 'slider' renders a bare <mat-slider> (slider.component.ts); a form-field wrapper throws
  // "mat-form-field must contain a MatFormFieldControl".
  'textarea',
  'toggle',
]);

/** Gives every control a stable outer anchor for current or future hover help. */
export function hoverTooltipExtension(field: FormlyFieldConfig): void {
  if (field.fieldGroup || field.key === undefined || field.key === null) {
    return;
  }

  const wrappers = field.wrappers ?? [];
  const innerWrappers = wrappers.filter(wrapper => wrapper !== 'hover-tooltip');

  if (typeof field.type === 'string' && MATERIAL_FORM_FIELD_TYPES.has(field.type) && !innerWrappers.includes('form-field')) {
    innerWrappers.push('form-field');
  }

  field.wrappers = ['hover-tooltip', ...innerWrappers];
}
